module.exports = __webpack_public_path__ + "static/sparda-bank-2d185c482ba0e3af171c5c271ec17739.svg";